import { render, staticRenderFns } from "./LoginBtn.vue?vue&type=template&id=a3ce744c&"
import script from "./LoginBtn.vue?vue&type=script&lang=js&"
export * from "./LoginBtn.vue?vue&type=script&lang=js&"
import style0 from "./LoginBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports